

<mat-toolbar>
    <span>{{itemDetails.Name}}</span>
    <span class="fill-remaining-space"></span>
    <button class="btn-dialog-close" mat-stroked-button (click)="onClose()"><mat-icon>clear</mat-icon></button>
  </mat-toolbar>


<form  [formGroup] ="addItemForm"  autocomplete="off" (ngSubmit)="addStockButtonClick()" class="form-horizontal">
  
    <div class="form-group">
      <input  name="id" readonly formControlName="id"  class="form-control"    type="hidden">
      </div>
    <div class="col-sm-12 pb-1">

        <div class="row">
        <div class="col-sm-12 mat-form-field-width">
            <mat-form-field appearance="outline">
            <mat-label>In Stock</mat-label>
            <input readonly formControlName="qtyInStock"  matInput>                 
            </mat-form-field>             
        </div>
        </div>


        <div class="row">
        <div class="col-sm-12 mat-form-field-width">
            <mat-form-field appearance="outline">
            <mat-label>Consumed Qty</mat-label>
            <input type="number"  formControlName="qty" [class.is-invalid]="formErrors.qty" (blur)="logValidationErrors()" matInput placeholder="Consumed Qty">                 
            <mat-error *ngIf="formErrors.qty">{{formErrors.qty}}</mat-error>
            </mat-form-field>             
        </div>
        </div>

      
      <div class="button-row justify-content-center mt-1">
        <button type="submit" [disabled]="!addItemForm.valid"  mat-raised-button color="primary" class="mr-2">
          <span *ngIf ="showProcessingIndicator" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Add Consumed Stock
        </button>         
      </div>

    </div>
  </form>


         


